import { KeyMetric, ChartData, ChartType } from '../../types';

// Mock Key Metrics
export const mockKeyMetrics: KeyMetric[] = [
  {
    id: '1',
    name: 'IRR',
    value: 14.2,
    unit: '%',
    trend: 0.5,
  },
  {
    id: '2',
    name: 'MOIC',
    value: 1.8,
    unit: 'x',
    trend: 0.1,
  },
  {
    id: '3',
    name: 'DSCR',
    value: 1.35,
    unit: '',
    trend: -0.05,
  },
  {
    id: '4',
    name: 'Occupancy',
    value: 92.5,
    unit: '%',
    trend: 1.5,
  },
  {
    id: '5',
    name: 'Rent PSF',
    value: 32.5,
    unit: '$/SF',
    trend: 2.1,
  },
];

// Mock Chart Data
export const mockChartData: ChartData[] = [
  {
    id: '1',
    title: 'Rent Roll Projection',
    type: ChartType.Line,
    data: [
      { year: 2023, value: 3200000 },
      { year: 2024, value: 3296000 },
      { year: 2025, value: 3394880 },
      { year: 2026, value: 3496726 },
      { year: 2027, value: 3601628 },
    ],
  },
  {
    id: '2',
    title: 'GLA by Tenant Type',
    type: ChartType.Pie,
    data: [
      { name: 'Anchor', value: 45000 },
      { name: 'Junior Anchor', value: 25000 },
      { name: 'Inline', value: 20000 },
      { name: 'Outparcel', value: 10000 },
    ],
  },
  {
    id: '3',
    title: 'LTV Ladder',
    type: ChartType.Bar,
    data: [
      { year: 2023, value: 65 },
      { year: 2024, value: 63 },
      { year: 2025, value: 61 },
      { year: 2026, value: 58 },
      { year: 2027, value: 55 },
    ],
  },
];
